
import Vue from "vue";

export default Vue.extend({
  props: {
    activity: { type: Object, required: true },
    detailUrl: { type: String, required: true },
    imageUrl: { type: String, required: true },
    formattedDate: { type: String, required: true },
  },
  computed: {
    activityName(): string {
      return (this.activity as any)?.name ?? "";
    },
  },
});
